var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.6688351px",
    height: "28.0000008px",
    viewBox: "0 0 25.6688351 28.0000008",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "heroicons:shopping-bag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sidebar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-Light-New-Icons",
    transform: "translate(-16.165, -779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "heroicons:shopping-bag",
    transform: "translate(13, 777)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,14 L21,8 C21,5.23857625 18.7614237,3 16,3 C13.2385763,3 11,5.23857625 11,8 L11,14 M26.1413333,11.3426667 L27.8253333,27.3426667 C27.9186667,28.2293333 27.2253333,29 26.3333333,29 L5.66666667,29 C5.2411789,29.000456 4.83551671,28.82019 4.55069764,28.5040917 C4.26587857,28.1879934 4.12870412,27.7658076 4.17333333,27.3426667 L5.85866667,11.3426667 C5.93918199,10.5792759 6.58304169,9.99999997 7.35066667,9.99999997 L24.6493333,9.99999997 C25.4173333,9.99999997 26.0613333,10.58 26.1413333,11.3426667 Z M11.5,14 C11.5,14.2761424 11.2761424,14.5 11,14.5 C10.7238576,14.5 10.5,14.2761424 10.5,14 C10.5,13.7238576 10.7238576,13.5 11,13.5 C11.2761424,13.5 11.5,13.7238576 11.5,14 Z M21.5,14 C21.5,14.2761424 21.2761424,14.5 21,14.5 C20.7238576,14.5 20.5,14.2761424 20.5,14 C20.5,13.7238576 20.7238576,13.5 21,13.5 C21.2761424,13.5 21.5,13.7238576 21.5,14 Z",
    id: "Shape",
    stroke: "#192340",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockBlack);
export default __webpack_public_path__ + "static/media/stock-black.5606c7dd0ea3cfbc8d3004567947b726.svg";
export { ForwardRef as ReactComponent };